export const SET_LOCALE = 'SET_LOCALE'
export const SEND_CONTACT_MESSAGE = 'SEND_CONTACT_MESSAGE'
export const SEND_CONTACT_MESSAGE_FAILED = 'SEND_CONTACT_MESSAGE_FAILED'
export const SEND_CONTACT_MESSAGE_RESET = 'SEND_CONTACT_MESSAGE_RESET'